import React from "react"
import { translate } from "react-i18next"
import PropTypes from "prop-types"
import { Button as ReactStrapButton } from "reactstrap"
import { Button } from "../themed-html-components"

function ReportGenerationButtons({
  t, resetHandler, submitHandler, submitEnabled,
}) {
  return (
    <div className="row form-group">
      <div className="col-lg-8 col-md-8" />
      <div className="col-lg-4 col-md-4">
        <ReactStrapButton onClick={resetHandler}>{t("CustomReport.Common.Reset")}</ReactStrapButton>
        &nbsp;
        <Button inverted onClick={submitHandler} disabled={submitEnabled === false}>
          {t("CustomReport.Common.Generate")}
        </Button>
      </div>
    </div>
  )
}

ReportGenerationButtons.propTypes = {
  resetHandler: PropTypes.func.isRequired,
  submitHandler: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  submitEnabled: PropTypes.bool.isRequired,
}

export default translate()(ReportGenerationButtons)



// WEBPACK FOOTER //
// ./src/components/custom-report/ReportGenerationButtons.jsx